import { listen, qsa, qs } from '@fluorescent/dom';
import noUiSlider from 'nouislider';

const priceRange = container => {
  const inputs = qsa('input', container);
  const minInput = inputs[0];
  const maxInput = inputs[1];
  const events = [listen(inputs, 'change', onRangeChange)];
  const slider = qs('[data-range-slider]');

  noUiSlider.create(slider, {
    start: [
      minInput.value ? minInput.value : minInput.getAttribute('min'),
      maxInput.value ? maxInput.value : maxInput.getAttribute('max'),
    ],
    connect: true,
    range: {
      'min': parseInt(minInput.getAttribute('min')),
      'max': parseInt(maxInput.getAttribute('max')),
    },
  });

  slider.noUiSlider.on('set', e => {
    let max, min;
    [min, max] = e;

    minInput.value = Math.floor(min);
    maxInput.value = Math.floor(max);
    fireChangeEvent();
    setMinAndMaxValues();
  });

  setMinAndMaxValues();

  function setMinAndMaxValues() {
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  function adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  function fireChangeEvent() {
    minInput.dispatchEvent(new Event('change', { bubbles: true }));
    maxInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onRangeChange(event) {
    adjustToValidValues(event.currentTarget);
    setMinAndMaxValues();

    if (minInput.value === '' && maxInput.value === '') return;

    let currentMax, currentMin;

    [currentMin, currentMax] = slider.noUiSlider.get();

    currentMin = Math.floor(currentMin);
    currentMax = Math.floor(currentMax);

    if (currentMin !== Math.floor(minInput.value)) slider.noUiSlider.set([minInput.value, null]);
    if (currentMax !== Math.floor(maxInput.value)) slider.noUiSlider.set([null, maxInput.value]);
  }

  function validateRange() {
    inputs.forEach(input => setMinAndMaxValues(input));
  }

  const reset = () => {
    slider.noUiSlider.set([
      minInput.getAttribute('min'),
      maxInput.getAttribute('max'),
    ]);
    minInput.value = '';
    maxInput.value = '';

    fireChangeEvent();

    setMinAndMaxValues();
  };

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return {
    unload,
    reset,
    validateRange,
  };
};

export default priceRange;
